// extracted by css-extract-rspack-plugin
export default {"editableLabel":"editableLabel-JP3ieS"};